import { PublicKey } from "@solana/web3.js";
import { SOLANA_NICKNAME_PROGRAM_PUBLIC_KEY } from "../useNickname";

export function deriveCorrectActionCostsPDA(nicknameAccount: PublicKey) {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("FEES_SEED_"), nicknameAccount.toBuffer()],
    SOLANA_NICKNAME_PROGRAM_PUBLIC_KEY
  );
}

export function deriveCorrectConfigPDA(nicknameAccount: PublicKey) {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("OWNER_CONFIG"), nicknameAccount.toBuffer()],
    SOLANA_NICKNAME_PROGRAM_PUBLIC_KEY
  );
}
